import { InsightsDateRange, InsightsUiFilters } from "./insightsHeader.models";

export const DEFAULT_INSIGHTS_UI_FILTERS: InsightsUiFilters = {};

export const DEFAULT_INSIGHTS_DATE_RANGE: InsightsDateRange = {
    startDate: null,
    endDate: null,
};

export const LIKE_OPERATOR = "like" as const;
export const IN_OPERATOR = "in" as const;
export const BETWEEN_OPERATOR = "between" as const;
export const CREATED_ON_KEY = "createdOn";
